import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import debitImage from "../../../../assets/images/debit5.png";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";

export default function TransactionTable(props) {
  const { transactionData } = props;
  return (
    <div>
      <Accordion style={{ width: "95%", marginLeft: "2rem", marginTop: "1em" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ borderBottom: "none" }}
        >
          <Typography component="span">
            {" "}
            <img style={{ marginRight: "0.5em" }} src={debitImage} />
            {`Gambling Transactions (${transactionData?.length})`}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead sx={{ backgroundColor: "#F6F9FF" }}>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell align="center" color="red">
                    Transaction Note
                  </TableCell>
                  <TableCell align="center" color="red">
                    Transaction Type
                  </TableCell>
                  <TableCell align="center">Amount</TableCell>
                  <TableCell align="center">Balance</TableCell>
                  <TableCell align="center">Category</TableCell>
                  <TableCell align="center">Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactionData?.length >= 1 ? (
                  <>
                    {transactionData?.map((row) => (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell scope="row">
                          {(row?.date).substr(0, 10)}
                        </TableCell>
                        <TableCell align="center">
                          {row.transaction_note}
                        </TableCell>
                        <TableCell align="center">
                          {row.transaction_type}
                        </TableCell>
                        <TableCell align="center">{row?.amount}</TableCell>
                        <TableCell align="center">{row?.balance}</TableCell>
                        <TableCell align="center">{row?.category}</TableCell>
                        <TableCell align="center">
                          {row?.metadata?.description}
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                ) : (
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell scope="row">No Gambling Transactions</TableCell>
                    <TableCell align="center">
                      No Gambling Transactions
                    </TableCell>
                    <TableCell align="center">
                      No Gambling Transactions
                    </TableCell>
                    <TableCell align="center">
                      No Gambling Transactions
                    </TableCell>
                    <TableCell align="center">
                      No Gambling Transactions
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
